import * as Icons from "heroicons-react";
import { useState } from "react";
import { Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import logo from "../../../logo.svg";
import { signInUser } from "../../Utility/Auth";
import { resolvePhotoUrl } from "../../Utility/resolvePhotoUrl";
import { useSettingsQuery } from "../../../services/settingsApi";
import { getDisplayLogo } from "../../Utility/packageHelper";
import "./SideBar.css";

const ManagerSideBar = () => {
  const auth = signInUser();
  const { aamarId, storeSettings } = auth || {};
  const { data: dbSettings } = useSettingsQuery(aamarId, { skip: !aamarId });
  const activeSettings = dbSettings || storeSettings;
  const storeLogoSrc = getDisplayLogo(auth, dbSettings, logo);
  let active = window.location.pathname;
  const [isSidebarOpen, setIsSidebarOpen] = useState(false); // State for toggle menu
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const [openMenus, setOpenMenus] = useState({}); // Track which menus are open
  const toggleMenu = (menuKey) => {
    setOpenMenus((prev) => ({
      ...prev,
      [menuKey]: !prev[menuKey], // Toggle the specific menu
    }));
  };
  const menuItems = [
    {
      key: "dashboard",
      label: "Dashboard",
      icon: <Icons.AdjustmentsOutline size={22} />,
      link: "/dashboard",
    },

    {
      key: "sales",
      label: "Sales",
      icon: <Icons.ShoppingCartOutline size={22} />,
      links: [
        {
          label: "Sales",
          to: "/sales",
          icon: <Icons.ShoppingCartOutline size={18} />,
        },
        ...(auth?.storeSettings?.isEnableApi
          ? [
              {
                label: "Ecom Sales",
                to: "/ecom",
                icon: <Icons.ShoppingCartOutline size={18} />,
              },
            ]
          : []),
        {
          label: "Customers",
          to: "/customer",
          icon: <Icons.UsersOutline size={18} />,
        },
        {
          label: "CustomerGroup",
          to: "/customerGroup",
          icon: <Icons.UsersOutline size={18} />,
        },
        {
          label: "Due Bills",
          to: "/duesale",
          icon: <Icons.ShoppingBagOutline size={18} />,
        },
      ],
    },

    {
      key: "products",
      label: "Products",
      icon: <Icons.ArchiveOutline size={22} />,
      links: [
        {
          label: "Products",
          to: "/product",
          icon: <Icons.ArchiveOutline size={18} />,
        },
        {
          label: "Category",
          to: "/category",
          icon: <Icons.CubeTransparentOutline size={18} />,
        },
        {
          label: "Sub Category",
          to: "/subcategory",
          icon: <Icons.CubeTransparentOutline size={18} />,
        },
        {
          label: "Brand",
          to: "/brand",
          icon: <Icons.SparklesOutline size={18} />,
        },
        // {
        //   label: "Unit",
        //   to: "/unit",
        //   icon: <Icons.ChipOutline size={18} />,
        // },
      ],
    },
    {
      key: "procurement",
      label: "Procurement",
      icon: <Icons.InboxInOutline size={22} />,
      links: [
        {
          label: "Purchase",
          to: "/purchase",
          icon: <Icons.CurrencyDollarOutline size={18} />,
        },
        {
          label: "GRN",
          to: "/grn",
          icon: <Icons.ClipboardCheckOutline size={18} />,
        },
        {
          label: "RTV",
          to: "/rtv",
          icon: <Icons.ReceiptRefundOutline size={18} />,
        },
        {
          label: "TPN",
          to: "/tpn",
          icon: <Icons.HomeOutline size={18} />,
        },
        {
          label: "Damage",
          to: "/damage",
          icon: <Icons.TrashOutline size={18} />,
        },
        {
          label: "Supplier",
          to: "/supplier",
          icon: <Icons.UsersOutline size={18} />,
        },
      ],
    },
    {
      key: "inventory",
      label: "Inventory",
      icon: <Icons.ViewGridAddOutline size={22} />,
      links: [
        {
          label: "Inventories",
          to: "/inventory",
          icon: <Icons.CollectionOutline size={18} />,
        },
        {
          label: "Adjust",
          to: "/adjust",
          icon: <Icons.SwitchVerticalOutline size={18} />,
        },

        {
          label: "Movement",
          to: "/product-movement",
          icon: <Icons.ArchiveOutline size={18} />,
        },
        {
          label: "Stock Ledger",
          to: "/stock-ledger",
          icon: <Icons.Table size={18} />,
        },
      ],
    },
    {
      key: "exports",
      label: "Exports",
      icon: <Icons.DownloadOutline size={22} />,
      link: "/exports",
    },
    {
      key: "settings",
      label: "Settings",
      icon: <Icons.CogOutline size={22} />,
      links: [
        {
          label: "Profile Settings",
          to: "/profile",
          icon: <Icons.UserOutline size={18} />,
        },
        {
          label: "Users",
          to: "/user",
          icon: <Icons.UsersOutline size={18} />,
        },

        {
          label: "SMS",
          to: "/sms",
          icon: <Icons.ChatAltOutline size={18} />,
        },
      ],
    },

    // Add more sections as needed
  ];
  return (
    <aside className="sticky-md-top ">
      <div className="d-flex pt-3 justify-content-between pb-2 gap-2 align-items-center">
        <Link className="nav-link logo w-100 d-flex justify-content-center align-items-center" to="/">
          <Image
            src={storeLogoSrc}
            fluid
            className="mx-auto d-block"
            style={{ maxHeight: "45px", maxWidth: "100%", objectFit: "contain" }}
            onError={(e) => {
              e.target.src = logo;
            }}
          />
        </Link>
        <div>
          <div onClick={toggleSidebar} className="me-2 d-block d-md-none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="size-6"
              style={{
                width: "24px", // Size of the icon
                height: "24px",
                color: "#333", // Icon color
              }}
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
              />
            </svg>
          </div>
          <nav className={`sidebar ${isSidebarOpen ? "open" : "closed"}`}>
            <div className="nav-links">
              <>
                <h2 className="mb-3 d-flex justify-content-center">
                  <Image
                    src={storeLogoSrc}
                    style={{ width: "150px", maxHeight: "50px", objectFit: "contain" }}
                    fluid
                    onError={(e) => {
                      e.target.src = logo;
                    }}
                  />
                </h2>
                {menuItems.map((menu) => (
                  <div key={menu.key}>
                    {/* Parent Link */}
                    <Link
                      className={`nav-link ${
                        openMenus[menu.key] ? "active" : ""
                      }`}
                      to={menu.links ? "#" : menu.link} // Use menu.link for items without submenus
                      onClick={() => menu.links && toggleMenu(menu.key)} // Toggle submenu visibility only if there are submenus
                    >
                      <div className="d-flex justify-content-between">
                        <span>
                          {menu.icon} {menu.label}
                        </span>
                        {/* Render arrow only for menu items with submenus */}
                        {menu.links && (
                          <span className="text-end">
                            {openMenus[menu.key] ? (
                              <Icons.ChevronDownOutline size={16} />
                            ) : (
                              <Icons.ChevronRightOutline size={16} />
                            )}
                          </span>
                        )}
                      </div>
                    </Link>

                    {/* Submenu Links */}
                    {openMenus[menu.key] && menu.links && (
                      <ul className="p-0 ps-4">
                        {menu.links.map((link, index) => (
                          <li key={index}>
                            <Link
                              className={`nav-link pt-0 ${
                                active === link.to ? "active" : ""
                              }`}
                              to={link.to}
                            >
                              {link.icon} {link.label}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
              </>
            </div>
          </nav>

          {/* Optional - When sidebar is closed, use backdrop (optional) */}
          <div
            className={`position-fixed top-0 start-0 w-100 h-100 bg-black opacity-50 ${
              isSidebarOpen ? "d-block" : "d-none"
            }`}
            onClick={toggleSidebar} // Close sidebar when backdrop is clicked
            style={{
              zIndex: "998", // Ensure backdrop is below sidebar
            }}
          ></div>
        </div>
      </div>
      <nav
        className="nav flex-column d-none d-sm-block"
        style={{ overflowY: "scroll", display: "block", height: "100vh" }}
      >
        <>
          {/* DASHBOARD */}
          <Link
            className={`nav-link ${active === "/dashboard" && "active"}`}
            to="/dashboard"
          >
            <Icons.AdjustmentsOutline size={22}></Icons.AdjustmentsOutline>{" "}
            Dashboard
          </Link>

          {/* POS */}
          {/* <Link
            className={`nav-link ${active === "/pos" && "active"}`}
            to="/pos"
          >
            <Icons.ShoppingBagOutline size={22} /> POS
          </Link> */}

          {/* SALES DW */}
          <Link
            className={`nav-link ${
              (active === "/ecom" ||
                active === "/sales" ||
                active === "/customer") &&
              "active"
            }`}
            to="/sales"
          >
            <div className="d-flex justify-content-between">
              <span>
                <Icons.ShoppingCartOutline size={22} /> Sales
              </span>
              <span className="text-end">
                {active === "/ecom" ||
                active === "/sales" ||
                active === "/customer" ? (
                  <Icons.ChevronDownOutline size={16} />
                ) : (
                  <Icons.ChevronRightOutline size={16} />
                )}
                {/*  */}
              </span>
            </div>
          </Link>
          <ul
            className={`p-0 ps-4 ${
              active === "/ecom" ||
              active === "/sales" ||
              // active === "/customer-ledger" ||
              active === "/customerGroup" ||
              active === "/duesale" ||
              active === "/customer"
                ? "d-bolck"
                : "d-none"
            }`}
          >
            <li>
              <Link
                className={`nav-link pt-0 ${active === "/sales" && "active"}`}
                to="/sales"
              >
                <Icons.ShoppingCartOutline
                  size={18}
                ></Icons.ShoppingCartOutline>{" "}
                Sales
              </Link>
            </li>
            {auth?.storeSettings?.isEnableApi ? (
              <li>
                <Link
                  className={`nav-link pt-0 ${active === "/ecom" && "active"}`}
                  to="/ecom"
                >
                  <Icons.ShoppingCartOutline
                    size={18}
                  ></Icons.ShoppingCartOutline>{" "}
                  Ecom Sales
                </Link>
              </li>
            ) : (
              ""
            )}
            <li>
              <Link
                className={`nav-link mt-0 ${
                  active === "/customer" && "active"
                }`}
                to="/customer"
              >
                <Icons.UsersOutline size={18}></Icons.UsersOutline> Customer
              </Link>
            </li>
            {/* <li>
              <Link
                className={`nav-link mt-0 ${
                  active === "/customer-ledger" && "active"
                }`}
                to="/customer-ledger"
              >
                <Icons.BookOpenOutline size={18}></Icons.BookOpenOutline>{" "}
                Customer Ledger
              </Link>
            </li> */}
            <li>
              <Link
                className={`nav-link mt-0 ${
                  active === "/customerGroup" && "active"
                }`}
                to="/customerGroup"
              >
                <Icons.UsersOutline size={18}></Icons.UsersOutline> Customer
                Group
              </Link>
            </li>
            <li>
              <Link
                className={`nav-link mt-0 ${active === "/duesale" && "active"}`}
                to="/duesale"
              >
                <Icons.ShoppingBagOutline size={18} /> Due Bills
              </Link>
            </li>
          </ul>

          {/* RPODUCT DW */}
          <Link
            className={`nav-link ${
              (active === "/product" ||
                active === "/prduct/import" ||
                active === "/price/import" ||
                active === "/product/add" ||
                active === "/brand" ||
                active === "/unit" ||
                active === "/category" ||
                active === "/subcategory" ||
                active === "/category/addCategory") &&
              "active"
            }`}
            to="/product"
          >
            <div className="d-flex justify-content-between">
              <span>
                <Icons.ArchiveOutline size={22} /> Products
              </span>
              <span className="text-end">
                {active === "/product" ||
                active === "/prduct/import" ||
                active === "/price/import" ||
                active === "/product/add" ||
                active === "/brand" ||
                active === "/unit" ||
                active === "/category" ||
                active === "/subcategory" ||
                active === "/category/addCategory" ? (
                  <Icons.ChevronDownOutline size={16} />
                ) : (
                  <Icons.ChevronRightOutline size={16} />
                )}
                {/*  */}
              </span>
            </div>
          </Link>
          <ul
            className={`p-0 ps-4 ${
              active === "/product" ||
              active === "/prduct/import" ||
              active === "/price/import" ||
              active === "/product/add" ||
              active === "/brand" ||
              active === "/unit" ||
              active === "/category" ||
              active === "/subcategory" ||
              active === "/category/addCategory"
                ? "d-bolck"
                : "d-none"
            }`}
          >
            <li>
              <Link
                className={`nav-link mt-0 ${
                  (active === "/product" ||
                    active === "/prduct/import" ||
                    active === "/price/import" ||
                    active === "/product/add") &&
                  "active"
                }`}
                to="/product"
              >
                <Icons.ArchiveOutline size={18} /> Products
              </Link>
            </li>
            <li>
              <Link
                className={`nav-link mt-0 ${
                  (active === "/category" ||
                    active === "/category/addCategory") &&
                  "active"
                }`}
                to="/category"
              >
                <Icons.CubeTransparentOutline
                  size={18}
                ></Icons.CubeTransparentOutline>{" "}
                Category
              </Link>
            </li>
            <li>
              <Link
                className={`nav-link mt-0 ${
                  (active === "/subcategory" ) &&
                  "active"
                }`}
                to="/subcategory"
              >
                <Icons.CubeTransparentOutline
                  size={18}
                ></Icons.CubeTransparentOutline>{" "}
                Sub Category
              </Link>
            </li>
            <li>
              <Link
                className={`nav-link mt-0 ${active === "/brand" && "active"}`}
                to="/brand"
              >
                <Icons.SparklesOutline size={18} /> Brand
              </Link>
            </li>
            {/* <li>
              <Link
                className={`nav-link mt-0 ${active === "/unit" && "active"}`}
                to="/unit"
              >
                <Icons.ChipOutline size={18} /> Unit
              </Link>
            </li> */}
          </ul>

          {/* procurement */}
          <Link
            className={`nav-link ${
              (active === "/purchase" ||
                active === "/purchase-create" ||
                active === "/grn" ||
                active === "/grn-create" ||
                active === "/grn-details" ||
                active === "/grn-summary" ||
                active === "/rtv" ||
                active === "/rtv-create" ||
                active === "/rtv-details" ||
                active === "/rtv-summary" ||
                active === "/tpn" ||
                active === "/tpn-out" ||
                active === "/tpn-details" ||
                active === "/tpn-summary" ||
                active === "/damage" ||
                active === "/damagecreate" ||
                active === "/damage-details" ||
                active === "/damage-summary" ||
                active === "/supplier" ||
                active === "/create-supplier") &&
              "active"
            }`}
            to="/purchase"
          >
            <div className="d-flex justify-content-between">
              <span>
                <Icons.InboxInOutline size={22} /> Procurement
              </span>
              <span className="text-end">
                {active === "/purchase" ||
                active === "/purchase-create" ||
                active === "/grn" ||
                active === "/grn-create" ||
                active === "/grn-details" ||
                active === "/grn-summary" ||
                active === "/rtv" ||
                active === "/rtv-create" ||
                active === "/rtv-details" ||
                active === "/rtv-summary" ||
                active === "/tpn" ||
                active === "/tpn-out" ||
                active === "/tpn-details" ||
                active === "/tpn-summary" ||
                active === "/damage" ||
                active === "/damagecreate" ||
                active === "/damage-details" ||
                active === "/damage-summary" ||
                active === "/supplier" ||
                active === "/create-supplier" ? (
                  <Icons.ChevronDownOutline size={16} />
                ) : (
                  <Icons.ChevronRightOutline size={16} />
                )}{" "}
              </span>
            </div>
          </Link>
          <ul
            className={`p-0 ps-4 ${
              active === "/purchase" ||
              active === "/purchase-create" ||
              active === "/grn" ||
              active === "/grn-create" ||
              active === "/grn-details" ||
              active === "/grn-summary" ||
              active === "/rtv" ||
              active === "/rtv-create" ||
              active === "/rtv-details" ||
              active === "/rtv-summary" ||
              active === "/tpn" ||
              active === "/tpn-out" ||
              active === "/tpn-details" ||
              active === "/tpn-summary" ||
              active === "/damage" ||
              active === "/damagecreate" ||
              active === "/damage-details" ||
              active === "/damage-summary" ||
              active === "/supplier" ||
              active === "/create-supplier"
                ? "d-bolck"
                : "d-none"
            }`}
          >
            <li>
              <Link
                className={`nav-link mt-0 ${
                  (active === "/purchase" || active === "/purchase-create") &&
                  "active"
                }`}
                to="/purchase"
              >
                <Icons.CurrencyDollarOutline
                  size={18}
                ></Icons.CurrencyDollarOutline>{" "}
                Purchase
              </Link>
            </li>
            <li>
              <Link
                className={`nav-link  pt-0 ${
                  (active === "/grn" ||
                    active === "/grn-create" ||
                    active === "/grn-details" ||
                    active === "/grn-summary") &&
                  "active"
                }`}
                to="/grn"
              >
                <Icons.ClipboardCheckOutline size={18} /> GRN
              </Link>
            </li>
            <li>
              <Link
                className={`nav-link pt-0 ${
                  (active === "/rtv" ||
                    active === "/rtv-create" ||
                    active === "/rtv-details" ||
                    active === "/rtv-summary") &&
                  "active"
                }`}
                to="/rtv"
              >
                <Icons.ReceiptRefundOutline size={18} /> RTV
              </Link>
            </li>

            <li>
              <Link
                className={`nav-link pt-0 ${
                  (active === "/tpn" ||
                    active === "/tpn-out" ||
                    active === "/tpn-details" ||
                    active === "/tpn-summary") &&
                  "active"
                }`}
                to="/tpn"
              >
                <Icons.HomeOutline size={18}></Icons.HomeOutline> TPN
              </Link>
            </li>

            <li>
              <Link
                className={`nav-link pt-0 ${
                  (active === "/damage" ||
                    active === "/damagecreate" ||
                    active === "/damage-details" ||
                    active === "/damage-summary") &&
                  "active"
                }`}
                to="/damage"
              >
                <Icons.TrashOutline size={18} /> Damage
              </Link>
            </li>

            <li>
              <Link
                className={`nav-link pt-0 ${
                  (active === "/supplier" || active === "/create-supplier") &&
                  "active"
                }`}
                to="/supplier"
              >
                <Icons.UsersOutline size={18}></Icons.UsersOutline> Supplier
              </Link>
            </li>
          </ul>

          {/* INVENTORY */}
          <Link
            className={`nav-link ${
              (active === "/inventory" ||
                active === "/adjust" ||
                active === "/product-movement" ||
                active === "/cogs") &&
              "active"
            }`}
            to="/inventory"
          >
            <div className="d-flex justify-content-between">
              <span>
                <Icons.ViewGridAddOutline size={22} /> Inventory
              </span>
              <span className="text-end">
                {active === "/inventory" ||
                active === "/adjust" ||
                active === "/cogs" ? (
                  <Icons.ChevronDownOutline size={16} />
                ) : (
                  <Icons.ChevronRightOutline size={16} />
                )}
                {/*  */}
              </span>
            </div>
          </Link>
          <ul
            className={`p-0 ps-4 ${
              active === "/inventory" ||
              active === "/adjust" ||
              active === "/product-movement" ||
              active === "/create-adjust" ||
              active === "/stock-ledger" ||
              active === "/cogs"
                ? "d-bolck"
                : "d-none"
            }`}
          >
            <li>
              <Link
                className={`nav-link pt-0 ${
                  active === "/inventory" && "active"
                }`}
                to="/inventory"
              >
                <Icons.CollectionOutline size={18} /> Inventories
              </Link>
            </li>
            <li>
              <Link
                className={`nav-link pt-0 ${active === "/adjust" && "active"}`}
                to="/adjust"
              >
                <Icons.SwitchVerticalOutline size={18} /> Adjust
              </Link>
            </li>
            {/* <li>
              <Link
                className={`nav-link pt-0 ${active === "/cogs" && "active"}`}
                to="/cogs"
              >
                <Icons.ReceiptTaxOutline size={18} /> COGS
              </Link>
            </li>*/}
            <li>
              <Link
                className={`nav-link ${
                  active === "/product-movement" && "active"
                }`}
                to="/product-movement"
              >
                <Icons.ArchiveOutline size={22} /> Movement
              </Link>
            </li>
            <li>
              <Link
                className={`nav-link ${
                  active === "/stock-ledger" && "active"
                }`}
                to="/stock-ledger"
              >
                <Icons.Table size={22} /> Stock Ledger
              </Link>
            </li>
          </ul>

          <Link
            className={`nav-link ${active === "/exports" && "active"}`}
            to="/exports"
          >
            <Icons.DownloadOutline size={22} /> Exports
          </Link>

          {/* SETTINGS */}
          <Link
            className={`nav-link ${
              (active === "/user" ||
                active === "/user/add" ||
                active === "/user/update" ||
                active === "/warehouse" ||
                active === "/sms" ||
                active === "/settings" ||
                active === "/profile") &&
              "active"
            }`}
            to="/profile"
          >
            <div className="d-flex justify-content-between">
              <span>
                <Icons.CogOutline size={22} /> Settings
              </span>
              <span className="text-end">
                {active === "/user" ||
                active === "/user/add" ||
                active === "/warehouse" ||
                active === "/sms" ||
                active === "/settings" ||
                active === "/profile" ? (
                  <Icons.ChevronDownOutline size={16} />
                ) : (
                  <Icons.ChevronRightOutline size={16} />
                )}
                {/*  */}
              </span>
            </div>
          </Link>
          <ul
            className={`p-0 ps-4 ${
              active === "/user" ||
              active === "/user/add" ||
              active === "/warehouse" ||
              active === "/sms" ||
              active === "/settings" ||
              active === "/profile"
                ? "d-bolck"
                : "d-none"
            }`}
          >
            <li>
              <Link
                className={`nav-link mt-0 ${active === "/profile" && "active"}`}
                to="/profile"
              >
                <Icons.UserOutline size={18} /> Profile Settings
              </Link>
            </li>
            <li>
              {/* USER */}
              <Link
                className={`nav-link mt-0 ${
                  (active === "/user" || active === "/user/add") && "active"
                }`}
                to="/user"
              >
                <Icons.UsersOutline size={18} /> Users
              </Link>
            </li>

            {/* WAREHOUSE */}
            {/* <li>
              <Link
                className={`nav-link mt-0 ${
                  active === "/warehouse" && "active"
                }`}
                to="/warehouse"
              >
                <Icons.HomeOutline size={18} /> Warehouse
              </Link>
            </li> */}
            <li>
              {/* SMS */}
              <Link
                className={`nav-link mt-0 ${active === "/sms" && "active"}`}
                to="/sms"
              >
                <Icons.ChatAltOutline size={18}></Icons.ChatAltOutline> SMS
              </Link>
            </li>
            {/* <li>
              <Link
                className={`nav-link mt-0 ${
                  active === "/settings" && "active"
                }`}
                to="/settings"
              >
                <Icons.CogOutline size={18} /> Store Settings
              </Link>
            </li> */}
          </ul>
        </>
      </nav>
    </aside>
  );
};

export default ManagerSideBar;
